/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Error_Kiotviet_Items_Unlinked_CountInputs */

const vi_error_kiotviet_items_unlinked_count = /** @type {(inputs: Error_Kiotviet_Items_Unlinked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.count} dòng chưa nối sản phẩm. Nối sản phẩm trước khi xuất kho.`)
};

/**

* @param {Error_Kiotviet_Items_Unlinked_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_items_unlinked_count = /** @type {((inputs: Error_Kiotviet_Items_Unlinked_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Items_Unlinked_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_items_unlinked_count(inputs)
});